import { IOpData, ICopyable, IOpChangeState, IJsonSerializable } from '../util/interfaces'
import { Enums } from '../common/enums'

import { OpDataType } from '../core/op-data-type'
import { Utils } from '../util/utils'


export class OpRouteData implements ICopyable<OpRouteData>, IJsonSerializable, IOpData, IOpChangeState {

    //#region Properties

    public idRouteData: number
    public idRoute: number
    public idDataType: number
    public indexNbr: number
    public value: any

    //#endregion


    //#region NavigationProperties

    private _dataType: OpDataType = null
    public get dataType(): OpDataType {
        return this._dataType
    }
    public set dataType(value: OpDataType) {
        this._dataType = value
        this.idDataType = value != null ? value.idDataType : null
    }

    //#endregion


    //#region Ctor

    constructor(opObj: any) {
        if (opObj instanceof OpRouteData) {
            this.copy(<OpRouteData>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    //#endregion


    //#region IOpChangeState Implementation

    public opState: Enums.OpChangeState

    //#endregion


    //#region IOpData Implementation

    public get idData() { return this.idRouteData }
    public set idData(idData: number) { this.idRouteData = idData }
    public get indexNBR() { return this.indexNbr }
    public set indexNBR(indexNBR: number) { this.indexNbr = indexNBR }

    //#endregion


    //#endregion IJsonSerializable Implementation

    public fromJSON(opObj: any, compress: boolean = false) {
        if (opObj) {
            this.dataType = opObj._DataType != null ? new OpDataType(opObj._DataType) : null

            this.idRouteData = opObj.ID_ROUTE_DATA
            this.idRoute = opObj.ID_ROUTE
            this.idDataType = opObj.ID_DATA_TYPE
            this.indexNbr = opObj.INDEX_NBR
            this.value = opObj.VALUE
        }
    }

    public toJSON(compress: boolean = false): any {
        return {
            ID_ROUTE_DATA: this.idRouteData,
            ID_ROUTE: this.idRoute,
            ID_DATA_TYPE: this.idDataType,
            INDEX_NBR: this.indexNbr,
            VALUE: this.value
        }
    }

    //#endregion


    //#region ICopyable Implementation

    public clone(includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpRouteData {
        const newRouteData: OpRouteData = new OpRouteData(null)

        newRouteData.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return newRouteData
    }

    public copy(source: OpRouteData, includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): void {
        if (source == null) {
            return
        }

        Utils.copyIOpData(this, source, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        this.idRoute = source.idRoute
        this.idRouteData = source.idRouteData
    }

    //#endregion


    //#region fromIOpData

    public static fromIOpData(data: IOpData): OpRouteData {
        const newData: OpRouteData = new OpRouteData(null)

        newData.idRouteData = data.idData
        newData.idDataType = data.idDataType
        newData.indexNbr = data.indexNBR
        newData.value = data.value
        newData.opState = data.opState

        return newData
    }

    //#endregion
}